module.exports = __webpack_public_path__ + "static/img/mEwm3.867b48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/mEwm3.png
// module id = xNK5
// module chunks = 0